import script from "./RoomOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoomOptions.vue?vue&type=script&lang=ts&setup=true"

import "./RoomOptions.vue?vue&type=style&index=0&id=3ddf1f19&lang=css"

const __exports__ = script;

export default __exports__